<template>
  <div class="menu-container">
    <nav class="fixed-menu">
      <div class="header">
        <router-link to="/">
          <img src="../assets/img/logo-central-da-marca.svg" alt="Logo Central da Marca" />
        </router-link>
      </div>
      <div class="menu-search" @click="openSearch">
        <span class="menu-search__icon" aria-hidden="true">
          <IconSearch />
        </span>
        <input
          type="text"
          class="menu-search__input"
          placeholder="Pesquisar"
          aria-label="Pesquisar"
          readonly
          @focus="openSearch"
        />
      </div>
      <ul>
        <li v-for="menuItem in menuItems"
          :key="menuItem.route"
          class="menu-item"
          :class="{'active-subroute': isSubRouteActive(menuItem)}"
          >
          <router-link
            class="menu-item__content"
            :to="{path: menuItem.route}"
            :class="[
              {
                active: isRouteActive(menuItem.route),
              },
              ...menuItem.classes || []]">
              {{ menuItem.label }}
              <div v-if="menuItem.submenu && menuItem.submenu.length >= 1"
                class="menu-item__dropdown-icon">
                <DropDownIcon />
              </div>
          </router-link>
          <ul v-if="menuItem.submenu" class="submenu">
            <li v-for="subMenuItem in menuItem.submenu"
              :key="subMenuItem.route"
              >
              <router-link
              :class="{'active-subroute': isRouteActive(subMenuItem.route)}"
              class="submenu-element"
                :to="{path: subMenuItem.route}">
                  {{ subMenuItem.label }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <SearchModal v-if="isSearchOpen" @close="closeSearch" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import DropDownIcon from '@/assets/icons/DropDownIcon.vue'
import IconSearch from '@/assets/icons/IconSearch.vue'
import SearchModal from '@/components/SearchModal.vue'

@Component({
  components: {
    DropDownIcon,
    IconSearch,
    SearchModal
  }
})
export default class MenuComponent extends Vue {
  showSidebar = true
  submenuVisible = false
  isSearchOpen = false
  menuItems = [{
    label: 'A Globo',
    route: '/globo'
  }, {
    label: 'Plataforma de Marca',
    route: '/plataforma-de-marca',
    submenu: [{
      label: 'Público',
      route: '/publico'
      },
      {
        label: 'Benefícios Diferenciadores',
        route: '/beneficios-diferenciadores'
      },
      {
        label: 'Crenças',
        route: '/nossas-crencas'
      },
      {
        label: 'Personalidade',
        route: '/personalidade'
      },
      {
        label: 'Vocação',
        route: '/vocacao'
      }
    ]
  }, 
  {
    label: 'Identidade Verbal',
    route: '/identidade-verbal',
    submenu: [
      {
        label: 'Persona',
        route: '/identidade-verbal/persona'
      },
      {
        label: 'Voz',
        route: '/identidade-verbal/voz'
      },
      {
        label: 'Tom',
        route: '/identidade-verbal/tom'
      },
      {
        label: 'Na Prática',
        route: '/identidade-verbal/na-pratica'
      }, 
      {
        label: 'Conteúdo',
        route: '/identidade-verbal/conteudo'
      },
      {
        label: 'Resumindo',
        route: '/identidade-verbal/resumindo'
      }
    ]
  }, 
  {
    label: 'Identidade Visual',
    route: '/identidade-visual',
    submenu: [
      {
        label: 'Logo',
        route: '/logo'
      },
      {
        label: 'Cores',
        route: '/cores'
      },
      {
        label: 'Tipografia',
        route: '/tipografia'  
      },
      {
        label: 'Iconografia',
        route: '/iconografia'  
      },
      {
        label: 'Grafismo',
        route: '/grafismos'  
      },
      {
        label: 'Ilustrações',
        route: '/ilustracao'  
      },
      {
        label: 'Fotografia',
        route: '/fotografia'  
      },
      {
        label: 'Grid',
        route: '/grid'  
      }
    ]
  }, 
  {
    label: 'Marcas da Globo',
    classes: ['disabled'],
    route: '/section6'
  },
  {
    label: 'Arquivos Úteis',
    route: '/arquivos-uteis'
  }]

  isRouteActive(route: string) {
    return this.$route.path === route
  }

  openSearch(): void {
    this.isSearchOpen = true
  }

  closeSearch(): void {
    this.isSearchOpen = false
  }

  isSubRouteActive(menuItem: any) {
    const hasActiveRoute = menuItem.submenu?.some((subMenuItem: any) => {
      return this.$route.path.startsWith(subMenuItem.route)
    })
    if (hasActiveRoute) {
      return true
    }
  }


  toggleSubmenu(): void {
    this.submenuVisible = !this.submenuVisible
  }

  async logout(): Promise<void> {
    await this.$store.dispatch('logout')
    this.$router.push({ name: 'logout' })
  }
}
</script>

<style lang="scss">
.menu-container {
  display: flex;
  width: 191px;
  position: relative;
  justify-content: center;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.fixed-menu {
  max-width: 191px;
  width: 100%;
  padding-top: 27px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
}

.fixed-menu ul {
  list-style-type: none;
  padding: 0;
}

.fixed-menu span {
  color: #101010;
  text-decoration: none;
  cursor: pointer;

  &.active {
    font-weight: bold;
  }

  &:hover {
    font-weight: bold;
  }
}

.fixed-menu a {
  color: #101010;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;

  &.active {
    font-weight: bold;
  }

  &:hover {
    font-weight: bold;
  }
}

.fixed-menu .submenu a {
  color: #101010;
  text-decoration: none;
  cursor: pointer;
}
.submenu{
  max-height: 0;
  visibility: hidden;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  padding: 0;
}
.menu-item:hover .submenu, .active-subroute .submenu {
  visibility: visible;
  max-height: 1000px;
  padding: 12px 0px;
}
.menu-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 30px;
  border-bottom: 1px solid #101010;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: 'GlobotipoCorporativaRegular';
    font-size: 14px;
    color: #101010;
    padding: 4px 0;
    &::placeholder {
      font-family: 'GlobotipoCorporativaRegular';
      color: #101010;
      opacity: 0.7;
    }
  }
}
.menu-item{
  padding: 12px 18px;
  &__content{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__dropdown-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
      transition: all 0.3s ease-in-out;
      transform: rotate(0);
      margin: auto;
    }
  }
  &:hover, &.active-subroute{
    .menu-item__dropdown-icon{
      svg{
        transition: all 0.3s ease-in-out;
        transform: rotate(-180deg);
      }
    }
  }
}
.fixed-menu .submenu-element{
  padding: 12px 18px;
  border-radius: 8px;
  background-color: none;
  display: block;
  visibility: 0;
  transition: visibility 0.3s ease-in-out;
  color: #101010;
  &:hover:not(.router-link-active){
    visibility: 1;
    background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
    color: white;
  }
  &.router-link-active {
    font-weight: bold;
  }
}

</style>
